// src/components/ui/TopBar.tsx — sticky inner-app header.
import type { ReactNode } from "react";
import { C, F } from "../../theme";

export interface TopBarProps {
  title: ReactNode;
  sub?: ReactNode;
  onBack?: () => void;
  right?: ReactNode;
}

export const TopBar = ({ title, sub, onBack, right }: TopBarProps) => (
  <div
    style={{
      position: "sticky",
      top: 0,
      zIndex: 50,
      background: C.paper,
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",
      borderBottom: `1px solid ${C.hairlineLt}`,
      padding: "14px 18px 12px",
      display: "flex",
      alignItems: "center",
      gap: 14,
    }}
  >
    {onBack ? (
      <button
        onClick={onBack}
        aria-label="Back"
        style={{
          width: 42,
          height: 42,
          borderRadius: 12,
          border: `1px solid ${C.hairline}`,
          background: C.card,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: C.shadowS,
          flexShrink: 0,
        }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={C.brassDk} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 12H5" />
          <path d="m12 5-7 7 7 7" />
        </svg>
      </button>
    ) : (
      <div
        style={{
          width: 38,
          height: 38,
          borderRadius: 10,
          background: C.brassDk,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "inset 0 1px 0 rgba(244,226,168,0.3), 0 1px 2px rgba(122,84,11,0.18)",
        }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={C.brassGlow} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect x="4" y="6" width="16" height="11" rx="2.5" />
          <line x1="4" y1="13" x2="20" y2="13" />
          <line x1="8" y1="20" x2="6" y2="17" />
          <line x1="16" y1="20" x2="18" y2="17" />
        </svg>
      </div>
    )}
    <div style={{ flex: 1, minWidth: 0 }}>
      <h1
        style={{
          fontFamily: F.serif,
          fontSize: onBack ? 20 : 19,
          fontWeight: 700,
          color: C.ink,
          margin: 0,
          lineHeight: 1.15,
          letterSpacing: -0.2,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {title}
      </h1>
      {sub && (
        <div
          style={{
            fontFamily: F.serif,
            fontStyle: "italic",
            fontSize: 12.5,
            fontWeight: 600,
            color: C.brassDk,
            marginTop: 1,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {sub}
        </div>
      )}
    </div>
    {right}
  </div>
);
